export enum VMClusterMeta {
  MODEL = "vmcluster",
  PK = "id",
}
